<script lang="ts" setup>
import type { InvestigationCollectionItem } from '@nuxt/content'

const route = useRoute('onderzoek-slug___nl')

const article = inject<InvestigationCollectionItem>('article')!

const { data: page } = await useAsyncData(route.path, () => {
  return queryCollection('investigationChapter')
    .path(route.path)
    .first()
})

useHead(page.value?.head || {})
useSeoMeta(page.value?.seo || {})
</script>

<template>
  <section v-if="page" class="p-4">
    <UBreadcrumb
      v-if="page && article"
      :items="[
        {
          label: 'Onderzoek',
          to: '/onderzoek',
        },
        {
          label: article.title,
          to: article.path,
        },
        {
          label: page.title,
        },
      ]" class="hidden lg:block mb-4"
    />
    <InvestigationArticleChaptersHeader :page="page" />
    <div class="mx-auto max-w-screen-md">
      <ContentRenderer v-if="page" :value="page" />
      <ApplicationArticleSurround :article="article" />
    </div>
  </section>
</template>
